import { IUser } from 'app/services/user';
import React from 'react';
import { useAuth } from 'utils/AuthProvider';
import PreviewExpandable from '../../components/PreviewExpandable';
import PreviewTable from '../../components/PreviewTable';

const fields: IBaseField<keyof IUser>[] = [
  {
    type: 'text',
    name: 'phone_number',
    label: 'Phone Number',
  },
  {
    type: 'text',
    name: 'email',
    label: 'Email Address',
  },
];

const PreviewAccountDetails = ({
  clients = [],
}: {
  clients: IUser[] | undefined;
}) => {
  return (
    <PreviewExpandable title="Account Details">
      {clients.map((c) => (
        <PreviewTable
          fields={fields}
          fieldsState={{
            values: {
              phone_number: c?.phone_number,
              email: c?.email,
            },
          }}
          sectionName="Account Details"
        />
      ))}
    </PreviewExpandable>
  );
};

export default PreviewAccountDetails;
